import { createLayoutRuntime } from './layout';
import { createTelegramRuntime } from './telegram';
import { createSupabaseRuntime, SupabaseRuntime } from './supabase';
import { getAppConfig } from './config';
import { createI18nRuntime } from './i18n';
import { initAnalytics, trackWebappOpen } from '../analytics';
import { initErrorMonitoring } from '../monitoring/errors';
import { createExperimentsRuntime, type ExperimentsRuntime } from '../experiments';

export type BootServices = {
  telegram: ReturnType<typeof createTelegramRuntime>;
  layout: ReturnType<typeof createLayoutRuntime>;
  supabase: SupabaseRuntime;
  config: ReturnType<typeof getAppConfig>;
  i18n: ReturnType<typeof createI18nRuntime>;
  experiments: ExperimentsRuntime;
};

let services: BootServices | null = null;

export function bootOnce(): BootServices {
  if (services) return services;

  const config = getAppConfig();
  const telegram = createTelegramRuntime();
  const layout = createLayoutRuntime();
  const supabase = createSupabaseRuntime();
  const i18n = createI18nRuntime();
  const experiments = createExperimentsRuntime({ supabase, config, i18n });

  telegram.init();
  layout.init();

  services = { telegram, layout, supabase, config, i18n, experiments };

  // Experiments runtime (best-effort; must not block app)
  experiments.init();

  // Инициализация аналитики
  initAnalytics(services);
  
  // Трекинг открытия WebApp (для DAU/MAU/Retention)
  trackWebappOpen();
  
  // Client error monitoring (best-effort, must not break app)
  initErrorMonitoring(services);

  return services;
}

